import React from 'react';
import { FolderOpen } from 'lucide-react';

export const EmptyState: React.FC = () => {
  return (
    <div className="flex flex-col h-full min-h-[400px] bg-background items-center justify-center p-8 text-center">
      <FolderOpen className="h-12 w-12 text-muted-foreground mb-4" aria-hidden />
      <h2 className="text-lg font-semibold text-foreground mb-2">
        Select a project to view the Project Control Console
      </h2>
      <p className="text-sm text-muted-foreground max-w-md">
        Choose a project from the sidebar or project selector to see schedule health, hotspots, and drill-through to Activities and Raw Data.
      </p>
    </div>
  );
};
